import { createFileRoute } from '@tanstack/react-router';
import AbsenceCreate from '~/containers/AbsenceCreate';

export const Route = createFileRoute('/absences/create')({
  component: AbsenceCreate,
  validateSearch(search) {
    return {
      from: (search.from as string) || undefined,
      publisherId: (search.publisherId as string) || undefined,
    };
  },
});
